import React from 'react'
import classNames from 'classnames'
import { autoFormat, formatters } from './utils'

export const CircularPercentageBar = ({ percent, color = 'rgba(59,130,246,.5)' }) => {
  const radius = 40
  const stroke = 5
  const normalizedRadius = radius - stroke * 2
  const strokeColor = color

  return (
    <div className='ProductTable__circularPercentageBar'>
      <svg height={radius * 2} width={radius * 2}>
        <circle
          stroke='lightgray'
          fill='transparent'
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          stroke={strokeColor}
          fill='transparent'
          strokeWidth={stroke}
          strokeDashoffset={25}
          strokeDasharray={percent + ' ' + (100 - percent)}
          pathLength={100}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <text
          x='50%'
          y='50%'
          dy='6px'
          dx='2px'
          textAnchor='middle'
          fill='black'
          style={{ fontSize: '16px' }}
        >
          {`${percent}%`}
        </text>
      </svg>
    </div>
  )
}

const Cell = ({ label, content, format, className, brand }) => {
  const formattedContent = format
    ? [{ size: 'big', word: formatters[format] ? formatters[format](content) : content }]
    : autoFormat(content)
  return (
    <div className={classNames('ProductTable__Cell', className)}>
      <span className='ProductTable__Cell__label'>{label}</span>
      <div className='ProductTable__Cell__content'>
        {format === 'circularPercentageBar' ? (
          <CircularPercentageBar percent={content} />
        ) : brand === 'money' ? (
          format ? (
            formatters[format](content)
          ) : (
            content
          )
        ) : (
          formattedContent.map((c, key) => {
            return c.size === 'small' ? (
              <span className='ProductTable__Cell__content--small' key={key}>
                {c.word}
              </span>
            ) : (
              c.word
            )
          })
        )}
      </div>
    </div>
  )
}

export default Cell
